import React, { useState } from "react";
import { CircularProgress, Grid2, Tooltip } from "@mui/material";
import PropTypes from "prop-types";

// styles
import styles from "./OrgInvitationStyles.module.scss";

//local imports
import { Actions } from "../../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../../Utils/storeUtils";

export default function OrganizationInvitation({
  invitations,
  setHasPlanCheck,
}) {
  const [loadingStates, setLoadingStates] = useState({});

  const handleAcceptInvitation = (invitation) => {
    setLoadingStates((prev) => ({ ...prev, [invitation.orgId]: "accepting" }));

    getStore().dispatch({
      type: Actions.API_UPDATE_ORG_USER_INVITATION,
      invitation,
      orgId: invitation.orgId,
      status: "ACCEPTED",
      meta: {
        onSuccess: () => {
          setLoadingStates((prev) => ({ ...prev, [invitation.orgId]: null }));
        },
        onError: () => {
          setLoadingStates((prev) => ({ ...prev, [invitation.orgId]: null }));
        },
      },
    });

    setTimeout(() => {
      getStore().dispatch({
        type: Actions.API_PERSONAL_DASHBOARD_STATS,
      });
    });
  };

  const handleRejectInvitation = (invitation) => {
    setLoadingStates((prev) => ({ ...prev, [invitation.orgId]: "rejecting" }));

    getStore().dispatch({
      type: Actions.API_UPDATE_ORG_USER_INVITATION,
      invitation,
      orgId: invitation.orgId,
      status: "REJECTED",
      meta: {
        onSuccess: () => {
          setLoadingStates((prev) => ({ ...prev, [invitation.orgId]: null }));
          getStore().dispatch({
            type: Actions.API_CHECK_USER_HAS_PLAN,
            meta: {
              onSuccess: (response) => {
                if (!response?.hasPlan) {
                  setHasPlanCheck(true);
                }
              },
            },
          });
        },
        onError: () => {
          setLoadingStates((prev) => ({ ...prev, [invitation.orgId]: null }));
        },
      },
    });
  };

  return (
    <Grid2 className={styles.container}>
      <Grid2 className={styles.label}>Organization Invitations</Grid2>
      <Grid2 className={styles.invitationContainer}>
        {invitations.map(
          (
            {
              icon: Icon,
              name,
              username,
              time,
              ownername,
              team,
              sites,
              ...invite
            },
            index
          ) => (
            <Grid2
              key={name}
              className={styles.invitation}
              sx={{ mb: index < invitations.length - 1 ? 2 : 0 }}
            >
              <Grid2 className={styles.detailsContainer}>
                <Icon className={styles.icon} />
                <Grid2>
                  <Grid2 className={styles.name}>{name}</Grid2>
                  <Grid2 className={styles.invitedByContainer}>
                    <Grid2 className={styles.invitedBy}>
                      You have been invited by
                    </Grid2>
                    <Grid2 className={styles.username}>{username}</Grid2>
                  </Grid2>
                  {/* <Grid2 className={styles.invitedBy}>{time}</Grid2> */}
                </Grid2>
              </Grid2>
              <Grid2 className={styles.ownerDetails}>
                <Grid2 className={styles.owner}>
                  <Grid2 className={styles.ownerText}>Owner :</Grid2>
                  <Tooltip title={ownername} arrow>
                    <Grid2 className={styles.ownerName}>{ownername}</Grid2>
                  </Tooltip>
                </Grid2>
                <Grid2 className={styles.team}>
                  <Grid2 className={styles.marginright}>Team Members :</Grid2>
                  <Grid2>{team}</Grid2>
                </Grid2>
                <Grid2 className={styles.sites}>
                  <Grid2 className={styles.marginright}>Sites :</Grid2>
                  <Grid2>{sites}</Grid2>
                </Grid2>
              </Grid2>
              <div className={styles.dottedLine} />
              <Grid2 className={styles.invite}>
                <Grid2
                  className={styles.ignore}
                  onClick={() => handleRejectInvitation(invite)}
                >
                  {loadingStates[invite.orgId] === "rejecting" ? (
                    <CircularProgress size={10} color="#ffffff" />
                  ) : (
                    "Ignore"
                  )}
                </Grid2>
                <Grid2
                  className={styles.accept}
                  onClick={() => handleAcceptInvitation(invite)}
                >
                  {loadingStates[invite.orgId] === "accepting" ? (
                    <CircularProgress size={10} color="#ffffff" />
                  ) : (
                    "Accept"
                  )}
                </Grid2>
              </Grid2>
            </Grid2>
          )
        )}
      </Grid2>
    </Grid2>
  );
}

OrganizationInvitation.propTypes = {
  invitations: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.elementType.isRequired,
      name: PropTypes.string.isRequired,
      username: PropTypes.string.isRequired,
      time: PropTypes.string.isRequired,
      ownername: PropTypes.string.isRequired,
      team: PropTypes.string.isRequired,
      sites: PropTypes.string.isRequired,
      orgId: PropTypes.string.isRequired,
    })
  ).isRequired,
};
